class LayoutConfig {
    width: KnockoutObservable<number>;
    height: KnockoutObservable<number>;
    left: KnockoutObservable<number>;
    top: KnockoutObservable<number>;

    constructor(data: any) {
        this.width = ko.observable(data.width);
        this.height = ko.observable(data.height);
        this.left = ko.observable(data.left);
        this.top = ko.observable(data.top);
    }
}